import script from "./CheckGoogle2FaCode.vue?vue&type=script&lang=ts&setup=true"
export * from "./CheckGoogle2FaCode.vue?vue&type=script&lang=ts&setup=true"

import "./CheckGoogle2FaCode.vue?vue&type=style&index=0&id=082f049d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-082f049d"]])

export default __exports__